module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-36.3f63ea12.png";